import { AccountSettingsThemes } from "modals/AccountSettingsThemes"

import { AccountRoutePanel } from "./shared"

export const ContractorThemePage = () => (
  <AccountRoutePanel>
    <AccountSettingsThemes />
  </AccountRoutePanel>
)
